module.exports = __webpack_public_path__ + "static/media/Camping_RewardBackground.96264b9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Camping_RewardBackground.png
// module id = 1354
// module chunks = 3